import Pagination from "./Pagination";
import UserLogRow from "./UserLogRow";
import "../monitor.css";

const UserLogsTable = ({ logs, pageTrack, pagination, onPageChange, onLimitChange }) => {
  return (
    <div
      className="monitor_container"
      style={{ height: "100%", display: "flex", flexDirection: "column", width: "100%" }}
    >
      <div className="table-wrapper">
        <table className="log-table">
          <thead>
            <tr>
              <th>User Email</th>
              <th>User ID</th>
              <th>Type</th>
              <th>Activity Time</th>
            </tr>
          </thead>

          <tbody>
            {logs.length === 0 ? (
              <tr>
                <td colSpan={4} style={{ textAlign: "center", padding: "16px", color: "#6b7280" }}>
                  No user logs found.
                </td>
              </tr>
            ) : (
              logs.map((log, index) => <UserLogRow key={log?.id || index} log={log} />)
            )}
          </tbody>
        </table>
      </div>

      <div className="pt_4">
        <Pagination
          pageTrack={pageTrack}
          pagination={pagination}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
        />
      </div>
    </div>
  );
};

export default UserLogsTable;
